PF.List.Select = class Select extends PF.Trait
	{
	initTrait()
		{
		this.bindDom({selectAll: 'show', delete: 'show'}, 'selectMode');
		this.dom.selectAll.on('click', () => this.selectAll());
		}

	selectAll()
		{
		let select = this.selected.length < this.length;
		for (let i = 0; i < this.length; i++)
			{
			this[i].selectState = select;
			}
		this.selectMode = true;
		}
	};